import { Link } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekLink = styled(Link)(({ theme }) => ({}));

export { PeekLink, PeekLink as default };
